import { CA_TYPE, setCA } from '@yuanfudao/metis-unified-login/es/constants/login'
import { cleanLoginStorage, getSearch, replaceGoToLogin } from '@yuanfudao/metis-unified-login/es/utils/login'
import config from './config'

setCA(CA_TYPE.FLYING)

replaceGoToLogin((loginConfig) => {
  cleanLoginStorage()
  // const search = getSearch()
  const { href } = window.location
  const [base] = href.split('#')
  window.location.replace(`${config.loginURL}?redirectUrl=${base}#/home`)
})
